import { ReactNode } from 'react';

import { SidebarDivider } from '@backstage/core-components';
import { IconComponent } from '@backstage/frontend-plugin-api';

import { ModuleIcons } from '@spotify/confidence-core-react';

export type MenuItem = {
  label: string;
  to: string;
  icon?: IconComponent;
  children?: MenuItem[];
};

export const isMenuItem = (value?: MenuItem | ReactNode): value is MenuItem =>
  value ? value.hasOwnProperty('to') : false;

export const getMenuLinks = ({
  isTotalConfidence,
  showEvents,
  showInitiatives,
  showMeasurements,
}: {
  isTotalConfidence: boolean;
  showEvents: boolean;
  showInitiatives: boolean;
  showMeasurements: boolean;
}): (MenuItem | ReactNode)[] => {
  return [
    {
      label: 'A/B Tests',
      to: '/workflows/abtest',
      icon: ModuleIcons.abtests,
    },
    {
      label: 'Rollouts',
      to: '/workflows/rollout',
      icon: ModuleIcons.rollouts,
    },
    ...(!isTotalConfidence
      ? [
          {
            label: 'Analyses',
            to: '/workflows/reanalysis',
            icon: ModuleIcons.analysis,
          },
        ]
      : []),
    <SidebarDivider />,
    {
      label: 'Flags',
      to: '/flags',
      icon: ModuleIcons.flags,
    },
    {
      label: 'Segments',
      to: '/segments',
      icon: ModuleIcons.segments,
    },
    <SidebarDivider />,
    {
      label: 'Metrics',
      to: '/metrics',
      icon: ModuleIcons.metrics,
      children: [
        {
          label: 'Metrics',
          to: '/metrics',
        },
        ...(showMeasurements
          ? [
              {
                label: 'Measurements',
                to: '/measurements',
              },
            ]
          : []),
        {
          label: 'Assignment tables',
          to: '/admin/assignment-tables',
        },
        {
          label: 'Fact tables',
          to: '/admin/fact-tables',
        },
        {
          label: 'Dimension tables',
          to: '/admin/dimension-tables',
        },
        {
          label: 'Entities',
          to: '/admin/entities',
        },
      ],
    },
    ...(showEvents || isTotalConfidence
      ? [
          {
            label: 'Events',
            to: '/events',
            icon: ModuleIcons.events,
          },
        ]
      : []),
    <SidebarDivider />,
    {
      icon: ModuleIcons.surfaces,
      to: '/surfaces',
      label: 'Surfaces',
    },
    ...(showInitiatives
      ? [
          {
            icon: ModuleIcons.initiatives,
            to: '/initiatives',
            label: 'Initiatives',
          },
        ]
      : []),
  ];
};
